import { httpService } from '../../../../../../../../../services/http.service';
import bugsnagHandler from '../../../../../../../../../services/bugsnag.service';
import { BASE_URL } from '../../../../../../../../../constants/endpoints';

export const markBillAsPaidAPIAction = async (customerId: string, externalId: string, billId: string, paymentTime: Date, paymentMethod: string) => {
  if (!customerId || !externalId || !billId) {
    bugsnagHandler.notify('Bill Pay - Bills Hub - Mark Bill as Paid Action - Missing customerId, externalId or billId');
    return false;
  }
  try {
    const { data } = await httpService.post(`${BASE_URL}/api/v1/user/${customerId}/${externalId}/bill/${billId}/markAsPaid`, { paymentTime, paymentMethod });
    return data;
  } catch (e: any) {
    bugsnagHandler.notify('Bill Pay - Bills Hub - Mark Bill as Paid Action - error marking bill as paid', e);
    throw e;
  }
};
